'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _BaseIcon2 = require('./BaseIcon');

var _BaseIcon3 = _interopRequireDefault(_BaseIcon2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*eslint-disable */
var User = function (_BaseIcon) {
  (0, _inherits3.default)(User, _BaseIcon);

  function User() {
    (0, _classCallCheck3.default)(this, User);
    return (0, _possibleConstructorReturn3.default)(this, (User.__proto__ || (0, _getPrototypeOf2.default)(User)).apply(this, arguments));
  }

  (0, _createClass3.default)(User, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'svg',
        this.getSvgProps(),
        _react2.default.createElement('path', (0, _extends3.default)({ d: 'M18.5315342 15.5435102c-1.072356-.4733878-2.6635068-1.6927347-5.0192876-2.111755.6023835-.6404083 1.058548-1.642041 1.5275342-2.8288164.271726-.6874286.2251233-1.2737143.2251233-2.1083266 0-.616653.1171234-1.6060408-.0369862-2.149959C14.708137 4.5071836 13.3951233 4 11.8567398 4c-1.5396165 0-2.8541097.5093878-3.3729042 2.3502857-.1528767.542204-.0355068 1.5293878-.0355068 2.1443265 0 .8365715-.045863 1.4245715.2266027 2.1134694.472685 1.192653.9221918 2.1928164 1.5223562 2.8305306-2.337041.4266123-3.9163562 1.637143-4.9818083 2.1090613C3.0108495 16.5240815 3 17.5930612 3 17.5930612v1.8159184l17.7551507-.002204V17.593061s-.0103562-1.072653-2.2236165-2.049551'
        }, this.getPathProps()))
      );
    }
  }]);
  return User;
}(_BaseIcon3.default);
/*eslint-enable */


User.defaultProps = {
  width: 18,
  height: 16,
  viewBox: '3 4 18 16'
};
exports.default = User;
//# sourceMappingURL=User.js.map


//////////////////
// WEBPACK FOOTER
// ../icon/lib/Icons/User.js
// module id = 328
// module chunks = 0